import { render, staticRenderFns } from "./haopinChuku.vue?vue&type=template&id=2c02b8a4&scoped=true"
import script from "./haopinChuku.vue?vue&type=script&lang=js"
export * from "./haopinChuku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02b8a4",
  null
  
)

export default component.exports